import {FormCheckboxType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const newsletterOptinField: FormCheckboxType = {
	amount: null,
	id: 0,
	parent_id: 0,
	channel: 'checkbox',
	label: copy?.newsletter || 'Ik schrijf me in op de nieuwsbrief',
	name: 'newsletter',
	required: false
}

export default newsletterOptinField
